import "./router/componentHooks";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/vue-i18n";
import "./plugins/vue-smart-widget";
import "./plugins/auth0";
import "./plugins/vue-md-editor";

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App),
}).$mount("#app");
